export default {
  state: {
    deliveryAddresses: []
  },
  actions: {
    loadDeliveryAddresses(ctx, data) {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = localStorage.getItem('access_token');

      if (user && user.id && token) {
        let url = `${data.path}/users/${user.id}/addresses?type=delivery`;
        let headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        };
        axios({
          method: 'GET',
          url: url,
          headers: headers,
        }).then(result => {
          ctx.commit('setDeliveryAddresses', result.data)
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  mutations: {
    setDeliveryAddresses(state, addresses) {
      state.deliveryAddresses = addresses;
    },
  },
  getters: {
    deliveryAddresses(state) {
      return state.deliveryAddresses
    }
  },
}
